// extracted by mini-css-extract-plugin
module.exports = {"whyUsItemEm":"why-us_whyUsItemEm___8fwy","screenshots":"why-us_screenshots__fih1r"};